import React from "react";
import {
  FaCalendarAlt,
  FaClock,
  FaUndo,
  FaMoneyBillWave,
  FaGift,
  FaRegCommentDots,
  FaUser,
  FaBan,
  FaCoins,
  FaTicketAlt,
  FaCheckCircle,
  FaUserShield,
  FaHandHoldingUsd,
} from "react-icons/fa";
import { TransactionLabel } from "../../types/user-transaction.entity";
import { UserTransactionLabelDisplay } from "../../utils/user-transaction-label-display";
import { transactionLabelStyles } from "../../utils/transaction-style";

const labelIconMap: Record<TransactionLabel, React.ElementType> = {
  BOOKED_MEETING: FaCalendarAlt,
  UPCOMING_MEETING: FaClock,
  BOOKING_REQUEST: FaTicketAlt,
  REFUND_DECLINED_REQUEST: FaUndo,
  REFUND_CANCELLED_MEETING: FaBan,
  REFUND_EXPIRED_REQUEST: FaUndo,
  REFUND_COACH_MISSED_MEETING: FaBan,
  COMPLETED_MEETING: FaCheckCircle,
  MEETING_EXTENSION_PAYMENT: FaMoneyBillWave,
  MEETING_EXTENSION_PAYOUT: FaMoneyBillWave,
  DIRECT_CALL: FaRegCommentDots,
  LOUNGE_DIRECT_CALL: FaRegCommentDots,
  TOP_UP: FaCoins,
  KARMA_PURCHASE: FaGift,
  MONEY_WITHDRAWAL: FaMoneyBillWave,
  COMPLETE_PROFILE: FaUser,
  LEFT_A_WORD_REFLECTION: FaRegCommentDots,
  AI_PRACTICE: FaRegCommentDots,
  REWARD_FOR_CANCELLED_SESSION: FaGift,
  REGISTER_COINS: FaCoins,
  CANCELLED_MEETING: FaBan,
  PARTIAL_PAYOUT_CANCELLED_MEETING: FaBan,
  FULL_PAYOUT_OF_CANCELLED_MEETING: FaBan,
  REFERRAL_REWARD: FaGift,
  ADMIN_SESSION_DEDUCTION: FaUserShield,
  ADMIN_SESSION_REFUND: FaHandHoldingUsd,
};

type Props = { label: TransactionLabel };

export const TransactionLabelPill: React.FC<Props> = ({ label }) => {
  const Icon = labelIconMap[label] || FaTicketAlt;
  const display = UserTransactionLabelDisplay[label];
  const styles = transactionLabelStyles[label];

  return (
    <span
      className={`
        inline-flex items-center
        px-3 py-1 text-sm font-medium
        rounded-full
        ${styles}
      `}
    >
      <Icon className="w-4 h-4 mr-2" />
      {display}
    </span>
  );
};
